import './Navbar.css'
import { faArrowAltCircleDown, faHouse } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from '../../../images/eslam-logo.png'


export default function Navbar() {





  return (
    <>
      <div className="section" id='section'>
      <div className="nav-bullets">
          <a href='#section'>
              <div className='bullet'>
                <div className="tooltip">Home</div>
              </div>
          </a>
          <a href='#about'>
              <div className='bullet'>
                <div className="tooltip">About</div>
              </div>
          </a>
          <a href='#skills'>
              <div className='bullet'>
                <div className="tooltip">Skills</div>
              </div>
          </a>
          <a href='#projects'>
              <div className='bullet'>
                <div className="tooltip">Projects</div>
              </div>
          </a>
          <a href='#contact'>
              <div className='bullet'>
                <div className="tooltip">Contact</div>
              </div>
          </a>
      </div>
      <div className="animation-area">
            <ul className="box-area">
                <li></li>
                <li></li>
                <li></li> 
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
	    </div>
        <div className="container">
          <div className="content">

            <div className="logo" data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="2000">
              <img className='logo' src={logo} alt="" />
              <div className="blur"></div>
            </div>
            

            <nav className="navbar navbar-expand-lg navbar-light" data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="2000">
              <div className="container">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <a className="nav-link actived" aria-current="page" href="ّ#section"><FontAwesomeIcon icon={faHouse} /></a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#about">About</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#skills">Skills</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#projects">Projects</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#contact">Contact</a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>

            <div className="button-cv" data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="2000">
              <a href='https://drive.google.com/file/d/1z3eGLrPfxgU6P1A86L2lbGtuWRontD6i/view?usp=sharing'target='_blank'  rel="noreferrer" className='btn-cv'><FontAwesomeIcon icon={faArrowAltCircleDown} /> My Resume</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
